import {dateFromServer} from "@/functions/dates.ts";
import {GetWorkspacePromotion, PromotionId, WorkspaceId} from "@/sdk.ts";

export class Promotion {
  readonly pid: PromotionId;
  readonly created_at: Date;
  readonly workspace_id: WorkspaceId;
  promotion_name: string;
  updated_at: Date | null;

  constructor(props: GetWorkspacePromotion.Result) {
    this.pid = props.pid;
    this.workspace_id = props.workspace_id;
    this.promotion_name = props.promotion_name;
    this.created_at = dateFromServer(props.created_at);
    this.updated_at = props.updated_at ? dateFromServer(props.updated_at) : null;
  }
}